define('lq/events/actions/eYouthAuthenticationCommand',[
    'underscore',
    'lq',
    'lq/events/actions/eventAction'
], function (_, lq, EventAction) {
    'use strict';

    function eYouthAuthenticationCommand(eventData, eventArg) {
        var self = this;
        EventAction.call(self, eventData, eventArg);

        self.authWindows = [];

        self.listenForMessage(function(e) {
            if (e.eventName === 'eYouthAuthenticated')
                self.triggerEvent('authenticated');
        });

        return self;
    }

    EventAction.extend(eYouthAuthenticationCommand, EventAction);

    eYouthAuthenticationCommand.typeName = 'eYouthAuthenticationCommand';

    eYouthAuthenticationCommand.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    eYouthAuthenticationCommand.prototype.execute = function (continuation) {
        var self = this;
        var w = 1030;
        var h = 774;
        var y = window.top.outerHeight / 2 + window.top.screenY - ( h / 2);
        var x = window.top.outerWidth / 2 + window.top.screenX - ( w / 2);
        self.authWindows.push(window.open(lq.getTenantUrl('Sso/eYouth'), 'eYouthAuth', 'scrollbars=on,top='+y+',left='+x+',width='+w+',height='+h));

        continuation();
    };

    eYouthAuthenticationCommand.prototype.listenForMessage = function (callback) {
        var eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
        var messageEvent = window.addEventListener ? 'message' : 'onmessage';
        var self = this;

        window[eventMethod](messageEvent, function (e) {
            if (!_.contains(self.authWindows, e.source))
                return;
            try {
                var eventObj = JSON.parse(e.data);
                callback(eventObj);
            } catch (err) {
                //could not parse, ignore it
            }

        }, false);
    };

    return eYouthAuthenticationCommand;
});
